export const SelectCustomStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: '12px',
    '&:hover': {
      borderColor: '#888',
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '12px',
    zIndex: 1000
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#f0f0f0' : '#fff',
    color: '#333',
    '&:hover': {
      backgroundColor: '#eee',
    },
  }),
};